import Vue from 'vue';

const EventBus = new Vue();

EventBus.listenerReady = false;

EventBus.myReportsListenerReady = false;
EventBus.myReportsWithIDListenerReady = false;

// Dashboard related bus
EventBus.statsListenerReady = false;
EventBus.activeStatsListeners = 0;

EventBus.campaignsReady = false;
EventBus.mediaReady = false;
EventBus.creativesReady = false;
EventBus.audienceReady = false;
EventBus.iosReady = false;
EventBus.publisherReady = false;

EventBus.performanceAPILoadedOnAIEnabled = false;

EventBus.universalPixelIdReady = false;

EventBus.campaignPromisesReady = false;

// By default, fetchSavedReports
EventBus.fetchSavedReports = true;

EventBus.universalPixelIdReady = false;

EventBus.isCampaignIdsReady = false;

EventBus.eventsLoaded = false;

EventBus.isOnAccountSettings = false;

EventBus.isAdvanceFilterLoaded = false;

EventBus.isChatbotClicked = false;

EventBus.isOverviewMountPending = false;

export default EventBus;
